"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = require("./constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterHelper = function () {

    var filterType = { FREE_TEXT: 1, DROP_DOWN: 2, DATE_PICKER: 3 };

    var globalUsersFilterOptions = [{
        type: _constants2.default.globalUsersFilterTypes.ALL_USERS,
        label: "All Users",
        isActive: true
    }, {
        type: _constants2.default.globalUsersFilterTypes.PAYG_USERS,
        label: "PAYG Customers",
        isActive: false
    }, {
        type: _constants2.default.globalUsersFilterTypes.NSW_CUSTOMERS,
        label: "NSW Customers",
        isActive: false
    }, {
        type: _constants2.default.globalUsersFilterTypes.VIC_CUSTOMERS,
        label: "VIC Customers",
        isActive: false
    }];

    var globalBusinessesFilterOptions = [{
        type: _constants2.default.globalBusinessesFilterTypes.ALL_BUSINESSS,
        label: "All Businesses",
        isActive: true
    }, {
        type: _constants2.default.globalBusinessesFilterTypes.NSW_BUSINESSES,
        label: "Targeted NSW",
        isActive: false
    }, {
        type: _constants2.default.globalBusinessesFilterTypes.VIC_BUSINESSES,
        label: "Targeted VIC",
        isActive: false
    }];

    var globalProfilesFilterOptions = [{
        type: _constants2.default.globalProfilesFilterTypes.ALL_PROFILES,
        label: "All Profiles",
        isActive: false
    }];

    var globalJobsFilterOptions = [{
        type: _constants2.default.globalJobsFilterTypes.ALL_JOBS,
        label: "All Jobs",
        isActive: true
    }, {
        type: _constants2.default.globalJobsFilterTypes.JOBS_POSTED_TODAY,
        label: "Jobs Posted Today",
        isActive: false
    }, {
        type: _constants2.default.globalJobsFilterTypes.JOBS_EXPIRE_TODAY,
        label: "Jobs Expire Today",
        isActive: false
    }, {
        type: _constants2.default.globalJobsFilterTypes.RECURRING_JOB_POSTED_15_DAYS_AGO,
        label: "Recurring Jobs Posted 15 Days Ago",
        isActive: false
    }];

    var globalJobRequestsFilterOptions = [{
        type: _constants2.default.globalJobRequestsFilterTypes.ALL_JOB_REQUESTS,
        label: "All Concierge Requests",
        isActive: true
    }];

    var globalAffiliatesFilterOptions = [{
        type: _constants2.default.globalAffiliatesFilterTypes.ALL_AFFILIATES,
        label: "All Partnerships",
        isActive: true
    }, {
        type: _constants2.default.globalAffiliatesFilterTypes.EMPLOYEE_BENEFITS,
        label: "Employee Benefits",
        isActive: false
    }, {
        type: _constants2.default.globalAffiliatesFilterTypes.REFERRALS,
        label: "Referrals",
        isActive: false
    }];

    var globalVouchesFilterOptions = [{
        type: _constants2.default.globalVouchesFilterTypes.ALL_VOUCHES,
        label: "All Vouches",
        isActive: true
    }];

    var globalBotManagerFilterOptions = [{
        type: _constants2.default.globalBotManagerFilterTypes.ALL_BOT_FLOWS,
        label: "All Flows",
        isActive: true
    }];

    var globalBotSessionsFilterOptions = [{
        type: _constants2.default.globalBotSessionsFilterTypes.ALL_BOT_SESSIONS,
        label: "All Sessions",
        isActive: true
    }];

    var globalCertificatesFilterOptions = [{
        type: _constants2.default.globalCertificatesFilterTypes.ALL_CERTIFICATES,
        label: "All Certificates",
        isActive: true
    }, {
        type: _constants2.default.globalCertificatesFilterTypes.PENDING_VERIFICATION,
        label: "Pending Verification",
        isActive: false
    }];

    var globalChecksFilterOptions = [{
        type: _constants2.default.globalChecksFilterTypes.ALL_CHECKS,
        label: "All Checks",
        isActive: true
    }];

    var profilesFilterOptions = [{
        field: "userId",
        label: "USER ID",
        icon: "fa-tag",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "fullName",
        label: "NAME",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "entityTypeName",
        label: "ACCOUNT TYPE",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "Family", label: "Family" },
            2: { value: "Business", label: "Business" },
            3: { value: "Helper", label: "Helper" }
        }
    }, {
        field: "accountStatusName",
        label: "ACCOUNT STATUS",
        icon: "fa-clock-o",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "Pending", label: "Pending" },
            2: { value: "Approved", label: "Approved" }
        }
    }, {
        field: "requiredReviews",
        label: "REVIEW TYPE",
        icon: "fa-bookmark",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "1", label: "New Profile" },
            2: { value: "32", label: "Missing About Me" },
            3: { value: "2", label: "Missing Au Pair Details" },
            4: { value: "4", label: "Missing Tuturing Details" },
            5: { value: "16", label: "Missing Certificate" },
            6: { value: "8", label: "Tutoring Category Changed" }
        }
    }, {
        field: "isHidden",
        label: "VISIBILITY",
        icon: "fa-eye",
        isActive: false,
        value: "",
        filterItemSelected: 1,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "false", label: "Visible" },
            2: { value: "true", label: "Hidden" }
        }
    }];

    var businessesFilterOptions = [{
        field: "locationId",
        label: "LEAD ID",
        icon: "fa-tag",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "name",
        label: "NAME",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "locationType",
        label: "BUSINESS TYPE",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.locationType.SCHOOL, label: "School" },
            2: { value: _constants2.default.locationType.CENTRE_BASED_DAYCARE, label: "Centre Day Care" },
            3: { value: _constants2.default.locationType.FAMILY_DAYCARE, label: "Family Day Care" },
            4: { value: _constants2.default.locationType.INHOME_CARE, label: "In-Home Care" },
            5: { value: _constants2.default.locationType.OUTSIDE_SCHOOL_HOURS_CARE, label: "OOSH" }
        }
    }, {
        field: "locationStatus",
        label: "LEAD STATUS",
        icon: "fa-bookmark",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.locationStatus.NEW_LEAD, label: "New Lead" },
            2: { value: _constants2.default.locationStatus.EDM_SENT, label: "EDM Sent" },
            // 3: { value: c.locationStatus.EDM_READY, label: "EDM Ready" },
            4: { value: _constants2.default.locationStatus.EDM_OPENED, label: "EDM Opened" },
            5: { value: _constants2.default.locationStatus.EDM_CLICKED, label: "EDM Clicked" },
            6: { value: _constants2.default.locationStatus.EDM_REJECTED, label: "EDM Rejected" },
            7: { value: _constants2.default.locationStatus.CALLS_COMMENCED, label: "Calls Commenced" },
            8: { value: _constants2.default.locationStatus.CONTACT_MADE, label: "Contact Made" },
            9: { value: _constants2.default.locationStatus.NOT_INTERESTED, label: "Not Interested" },
            10: { value: _constants2.default.locationStatus.INTERESTED_IN_PROGRESS, label: "Interested In-Progress" },
            11: { value: _constants2.default.locationStatus.ACQUIRED, label: "Acquired" }
        }
    }, {
        field: "helpersCount",
        label: "HELPERS COUNT",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "less than", operator: "lt" },
            3: { value: 3, label: "greater than", operator: "gt" }
        }
    }, {
        field: "state",
        label: "STATE",
        icon: "fa-map-marker",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { label: 'NSW', value: 'nsw' },
            2: { label: 'ACT', value: 'act' },
            3: { label: 'VIC', value: 'vic' },
            4: { label: 'SA', value: 'sa' },
            5: { label: 'QLD', value: 'qld' },
            6: { label: 'NT', value: 'nt' },
            7: { label: 'WA', value: 'wa' },
            8: { label: 'TAS', value: 'ta' }
        }
    }];

    var usersFilterOptions = [{
        field: "userId",
        label: "USER ID",
        icon: "fa-tag",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "fullName",
        label: "NAME",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "entityTypeName",
        label: "ACCOUNT TYPE",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "Family", label: "Family" },
            2: { value: "Business", label: "Business" },
            3: { value: "Helper", label: "Helper" }
        }
    }, {
        field: "membershipTypeName",
        label: "MEMBERSHIP TYPE",
        icon: "fa-bookmark",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "Free", label: "All" },
            // 2: { value: "PayAsYouGo", label: "Pay as you go" },
            3: { value: "Subscription", label: "Subscription" }
        }
    }, {
        field: "accountStatusName",
        label: "ACCOUNT STATUS",
        icon: "fa-clock-o",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "Pending", label: "Pending" },
            2: { value: "Approved", label: "Approved" }
        }
    }, {
        field: "email",
        label: "EMAIL",
        icon: "fa-at",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "phoneNumber",
        label: "PHONE NUMBER",
        icon: "fa-phone",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "hasProfileVideo",
        label: "HAS PROFILE VIDEO",
        icon: "fa-play",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "true", label: "Yes" },
            2: { value: "false", label: "No" }
        }
    }, {
        field: "paymentInfo.payingMemberSince",
        label: "PAYING MEMBER SINCE",
        icon: "fa-calendar",
        isActive: false,
        value: 1,
        filterItemSelected: 1,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            // 1: { value: 1, label: "greater than", operator: "gt" },
            // 2: { value: 2, label: "less than", operator: "lt" },
            1: { value: 1, label: "has any value", operator: "isnotnull", hideValueField: true }
        }
    }, {
        field: "isImageCropped",
        label: "HAS CROPPED PICTURE",
        icon: "fa-photo",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "true", label: "Yes" },
            2: { value: "false", label: "No" }
        }
    }, {
        field: "isHidden",
        label: "ACCOUNT VISIBILITY",
        icon: "fa-eye",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "false", label: "Visible" },
            2: { value: "true", label: "Hidden" }
        }
    }, {
        field: "addresses.formattedSuburb",
        label: "SUBURB",
        icon: "fa-map-marker",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "addresses.state",
        label: "REGION/CITY",
        icon: "fa-map-marker",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "addresses.state",
        label: "STATE",
        icon: "fa-map-marker",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { label: 'NSW', value: 'nsw' },
            2: { label: 'ACT', value: 'act' },
            3: { label: 'VIC', value: 'vic' },
            4: { label: 'SA', value: 'sa' },
            5: { label: 'QLD', value: 'qld' },
            6: { label: 'NT', value: 'nt' },
            7: { label: 'WA', value: 'wa' },
            8: { label: 'TAS', value: 'ta' }
        }
    }, {
        field: "country",
        label: "COUNTRY",
        icon: "fa-map-marker",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { label: 'Australia', value: 'au' },
            2: { label: 'New Zealand', value: 'nz' }
        }
    }, {
        field: "interestedInJobTypes",
        label: "JOB TYPE",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.jobType.BABYSITTING, label: "Babysitting" },
            3: { value: _constants2.default.jobType.NANNYING, label: "Nannying (Daytime Care)" },
            4: { value: _constants2.default.jobType.BEFORE_SCHOOL_CARE, label: "Before School Care" },
            5: { value: _constants2.default.jobType.AFTER_SCHOOL_CARE, label: "After School Care" },
            6: { value: _constants2.default.jobType.BEFORE_AFTER_SCHOOL_CARE, label: "Before and After School Care" },
            7: { value: _constants2.default.jobType.AU_PAIR, label: "Au Pair" },
            8: { value: _constants2.default.jobType.PRIMARY_SCHOOL_TUTORING, label: "Primary School Tutoring" },
            9: { value: _constants2.default.jobType.HIGH_SCHOOL_TUTORING, label: "High School Tutoring" },
            10: { value: _constants2.default.jobType.ONE_OFF_ODD_JOBS, label: "Odd Job" }
        }
    }, {
        field: "clientInfo.jobsPlaced",
        label: "JOB POSTS",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "less than", operator: "lt" },
            3: { value: 3, label: "greater than", operator: "gt" }
        }
    }, {
        field: "affiliateCode",
        label: "AFFILIATE CODE",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }];

    var mediaFilterOptions = [{
        field: "fullName",
        label: "NAME",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "mediaReviewStatus",
        label: "MEDIA REVIEW STATUS",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.mediaReviewStatuts.UNSPECIFIED, label: "Unspecified" },
            2: { value: _constants2.default.mediaReviewStatuts.PENDING, label: "Pending" },
            3: { value: _constants2.default.mediaReviewStatuts.APPROVED, label: "Approved" },
            4: { value: _constants2.default.mediaReviewStatuts.REJECTED, label: "Rejected" }
        }
    }];

    var surveyFilterOptions = [{
        field: "fullName",
        label: "NAME",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "interestInHomeAgedCareResponse",
        label: "RESPONSES",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.surveyResponse.YES, label: "Yes" },
            2: { value: _constants2.default.surveyResponse.NO, label: "No" },
            3: { value: _constants2.default.surveyResponse.NA, label: "NA" }
        }
    }, {
        field: "jugglerType",
        label: "ACCOUNT TYPE",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.jugglerType.PARENT, label: "Family" },
            2: { value: _constants2.default.jugglerType.HELPER, label: "Helper" }
        }
    }];

    var certificatesFilterOptions = [{
        field: "fullName",
        label: "NAME",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "gender",
        label: "GENDER",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: 1, label: "Male" },
            2: { value: 2, label: "Female" },
            3: { value: 0, label: "Prefer not to say" }
        }
    }, {
        field: "accountStatus",
        label: "ACCOUNT STATUS",
        icon: "fa-clock-o",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.accountStatus.PENDING, label: "Pending" },
            2: { value: _constants2.default.accountStatus.APPROVED, label: "Approved" }
        }
    }, {
        field: "addresses.state",
        label: "STATE",
        icon: "fa-map-marker",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { label: 'NSW', value: 'nsw' },
            2: { label: 'ACT', value: 'act' },
            3: { label: 'VIC', value: 'vic' },
            4: { label: 'SA', value: 'sa' },
            5: { label: 'QLD', value: 'qld' },
            6: { label: 'NT', value: 'nt' },
            7: { label: 'WA', value: 'wa' },
            8: { label: 'TAS', value: 'ta' }
        }
    }, {
        field: "membershipType",
        label: "MEMBERSHIP TYPE",
        icon: "fa-bookmark",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.membershipType.free, label: "All" },
            // 2: { value: c.membershipType.payg, label: "PayAsYouGo"},
            3: { value: _constants2.default.membershipType.subscription, label: "Subscription" }
        }
    }, {
        field: "certificateStatus",
        label: "CERTIFICATE STATUS",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.certificateStatus.PENDINGVERIFICATION, label: "Pending Verification" },
            2: { value: _constants2.default.certificateStatus.ACTIVE, label: "Active" },
            3: { value: _constants2.default.certificateStatus.INVALID, label: "Invalid" },
            4: { value: _constants2.default.certificateStatus.EXPIRED, label: "Expired" }
        }
    }, {
        field: "isHidden",
        label: "ACCOUNT VISIBILITY",
        icon: "fa-eye",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "false", label: "Visible" },
            2: { value: "true", label: "Hidden" }
        }
    }];

    var checksFilterOptions = [{
        field: "fullName",
        label: "NAME",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "accountStatus",
        label: "ACCOUNT STATUS",
        icon: "fa-clock-o",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.accountStatus.PENDING, label: "Pending" },
            2: { value: _constants2.default.accountStatus.APPROVED, label: "Approved" }
        }
    }, {
        field: "country",
        label: "COUNTRY",
        icon: "fa-map-marker",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { label: 'Australia', value: 'au' },
            2: { label: 'New Zealand', value: 'nz' }
        }
    }, {
        field: "membershipType",
        label: "MEMBERSHIP TYPE",
        icon: "fa-bookmark",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.membershipType.free, label: "All" },
            // 2: { value: c.membershipType.payg, label: "PayAsYouGo"},
            3: { value: _constants2.default.membershipType.subscription, label: "Subscription" }
        }
    }, {
        field: "visaCheckStatus",
        label: "CHECK STATUS",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.visaCheckStatus.PENDINGVERIFICATION, label: "Pending Verification" },
            2: { value: _constants2.default.visaCheckStatus.APPROVED, label: "Approved" },
            3: { value: _constants2.default.visaCheckStatus.INVALID, label: "Invalid" },
            4: { value: _constants2.default.visaCheckStatus.EXPIRED, label: "Expired" }
        }
    }, {
        field: "isHidden",
        label: "ACCOUNT VISIBILITY",
        icon: "fa-eye",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "false", label: "Visible" },
            2: { value: "true", label: "Hidden" }
        }
    }];

    var jobsFilterOptions = [{
        field: "jobId",
        label: "JOB REFERENCE",
        icon: "fa-tag",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" }
        }
    }, {
        field: "daysSincePost",
        label: "DAYS SINCE POST",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" }
        }
    }, {
        field: "expiresInDays",
        label: "EXPIRES IN DAYS",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" }
        }
    }, {
        field: "postDate",
        label: "JOB POST DATE",
        icon: "fa-calendar",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DATE_PICKER,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "before", operator: "lt" },
            3: { value: 3, label: "after", operator: "gt" }
        }
    }, {
        field: "jobDate",
        label: "JOB START DATE",
        icon: "fa-calendar",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DATE_PICKER,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" }
        }
    },
    // {
    //     field: "jobFinishDate",
    //     label: "JOB FINISH DATE",
    //     icon: "fa-calendar",
    //     isActive: false,
    //     value: "",
    //     filterItemSelected: 0,
    //     filterType: filterType.DATE_PICKER,
    //     filterIitems: {
    //         1: { value: 1, label: "is", operator: "eq" },
    //     }
    // },
    {
        field: "userNumberOfJobPosts",
        label: "TOTAL JOB POSTS",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "less than", operator: "lt" },
            3: { value: 3, label: "greater than", operator: "gt" }
        }
    }, {
        field: "userId",
        label: "USER ID",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" }
        }
    }, {
        field: "jobType",
        label: "JOB TYPE",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.jobType.BABYSITTING, label: "Babysitting" },
            2: { value: _constants2.default.jobType.RECURRING_JOB, label: "Recurring Jobs (All Types)" },
            3: { value: _constants2.default.jobType.NANNYING, label: "Nannying (Daytime Care)" },
            4: { value: _constants2.default.jobType.BEFORE_SCHOOL_CARE, label: "Before School Care" },
            5: { value: _constants2.default.jobType.AFTER_SCHOOL_CARE, label: "After School Care" },
            6: { value: _constants2.default.jobType.BEFORE_AFTER_SCHOOL_CARE, label: "Before and After School Care" },
            7: { value: _constants2.default.jobType.AU_PAIR, label: "Au Pair" },
            8: { value: _constants2.default.jobType.PRIMARY_SCHOOL_TUTORING, label: "Primary School Tutoring" },
            9: { value: _constants2.default.jobType.HIGH_SCHOOL_TUTORING, label: "High School Tutoring" },
            10: { value: _constants2.default.jobType.ONE_OFF_ODD_JOBS, label: "Odd Job" }
        }
    }, {
        field: "jobStatus",
        label: "JOB STATUS",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.jobStatus.AWARDED, label: "Awarded" },
            2: { value: _constants2.default.jobStatus.CANCELLED, label: "Cancelled" },
            3: { value: _constants2.default.jobStatus.COMPLETED, label: "Completed" },
            4: { value: _constants2.default.jobStatus.FILLED, label: "Filled" },
            5: { value: _constants2.default.jobStatus.PENDING, label: "Pending" },
            6: { value: _constants2.default.jobStatus.FILLED_AND_CANCELLED, label: "Filled and Closed" }
        }
    }, {
        field: "managedBy",
        label: "Management",
        icon: "fa-gear",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.managedBy.USER, label: "Do It Yourself" },
            2: { value: _constants2.default.managedBy.SYSTEM, label: "Juggle Assist" }
        }
    }, {
        field: "country",
        label: "COUNTRY",
        icon: "fa-map-marker",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { label: 'Australia', value: 'au' },
            2: { label: 'New Zealand', value: 'nz' }
        }
    }, {
        field: "addresses.state",
        label: "STATE",
        icon: "fa-map-marker",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { label: 'NSW', value: 'nsw' },
            2: { label: 'ACT', value: 'act' },
            3: { label: 'VIC', value: 'vic' },
            4: { label: 'SA', value: 'sa' },
            5: { label: 'QLD', value: 'qld' },
            6: { label: 'NT', value: 'nt' },
            7: { label: 'WA', value: 'wa' },
            8: { label: 'TAS', value: 'ta' }
        }
    }];

    var jobRequestsFilterOptions = [{
        field: "",
        label: "REQUEST STATUS",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.jobRequestStatus.NEW_REQUEST, label: "New Request" },
            2: { value: _constants2.default.jobRequestStatus.CALL_SCHEDULED, label: "Call Scheduled" },
            3: { value: _constants2.default.jobRequestStatus.JOB_POSTED, label: "Job Posted" },
            4: { value: _constants2.default.jobRequestStatus.JOB_TRANSFERRED, label: "Job Transferred" },
            5: { value: _constants2.default.jobRequestStatus.JOB_AWARDED, label: "Job Awarded" }
        }
    }];

    var affiliatesFilterOptions = [{
        field: "affiliateSource",
        label: "AFFILIATE SOURCE",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { label: 'Referrals', value: 1 },
            2: { label: 'Employee Benefits', value: 2 }
        }
    }, {
        field: "affiliateStatus",
        label: "AFFILIATE STATUS",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { label: 'All', value: 0 },
            2: { label: 'Used', value: 1 },
            3: { label: 'Activated', value: 2 }
        }
    }, {
        field: "affiliateName",
        label: "PARTNER NAME",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "code",
        label: "PARTNER CODE",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }];

    var vouchesFilterOptions = [{
        field: "userId",
        label: "USER ID",
        icon: "fa-tag",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" }
        }
    }, {
        field: "fullName",
        label: "USER NAME",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "status",
        label: "STATUS",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.vouchStatus.PENDING, label: "Follow-up" },
            2: { value: _constants2.default.vouchStatus.APPROVED, label: "Complete" },
            3: { value: _constants2.default.vouchStatus.CANCELLED, label: "Incomplete" },
            4: { value: _constants2.default.vouchStatus.EXPIRED, label: "Expired" }
            // 5: { value: c.vouchStatus.NONE, label: "-" },
        }
    }, {
        field: "accountStatus",
        label: "ACCOUNT STATUS",
        icon: "fa-clock-o",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: _constants2.default.accountStatus.PENDING, label: "Pending" },
            2: { value: _constants2.default.accountStatus.PENDING_APPROVAL, label: "Pending 100%" },
            3: { value: _constants2.default.accountStatus.APPROVED, label: "Approved" }
        }
    }, {
        field: "isHidden",
        label: "VISIBILITY",
        icon: "fa-eye",
        isActive: false,
        value: "",
        filterItemSelected: 1,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "false", label: "Visible" },
            2: { value: "true", label: "Hidden" }
        }
    }, {
        field: "interestedInAuPairJobs",
        label: "IS AU PAIR",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "true", label: "Yes" },
            2: { value: "false", label: "No" }
        }
    }, {
        field: "referenceType",
        label: "REF TYPE",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            // 1: { value: c.vouchReferenceType.FAMILY, label: "Family" },
            // 2: { value: c.vouchReferenceType.CHILDCAREEMPLOYMENT, label: "Childcare Employment" },
            // 3: { value: c.vouchReferenceType.NONCHILDCAREEMPLOYMENT, label: "Non-childcare Employment" },
            // 4: { value: c.vouchReferenceType.OTHER, label: "Other" },
            1: { value: _constants2.default.vouchReferenceType.REFERENCES, label: "References" },
            2: { value: _constants2.default.vouchReferenceType.JUGGLESTREET, label: "Juggle Street" }
        }
    }, {
        field: "state",
        label: "REGION/CITY",
        icon: "fa-map-marker",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "state",
        label: "STATE",
        icon: "fa-map-marker",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { label: 'NSW', value: 'nsw' },
            2: { label: 'ACT', value: 'act' },
            3: { label: 'VIC', value: 'vic' },
            4: { label: 'SA', value: 'sa' },
            5: { label: 'QLD', value: 'qld' },
            6: { label: 'NT', value: 'nt' },
            7: { label: 'WA', value: 'wa' },
            8: { label: 'TAS', value: 'ta' }
        }
    }, {
        field: "country",
        label: "COUNTRY",
        icon: "fa-map-marker",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { label: 'Australia', value: 'au' },
            2: { label: 'New Zealand', value: 'nz' }
        }
    }];

    var botManagerFilterOptions = [{
        field: "flowType",
        label: "FLOW TYPE",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "contains", operator: "contains" }
        }
    }];

    var botSessionsFilterOptions = [{
        field: "userName",
        label: "User Name",
        icon: "fa-user",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.FREE_TEXT,
        filterIitems: {
            1: { value: 1, label: "is", operator: "eq" },
            2: { value: 2, label: "contains", operator: "contains" }
        }
    }, {
        field: "channelId",
        label: "Channel",
        icon: "fa-ticket",
        isActive: false,
        value: "",
        filterItemSelected: 0,
        filterType: filterType.DROP_DOWN,
        filterIitems: {
            1: { value: "facebook", label: "Facebook" },
            2: { value: "emulator", label: "Emulator" }
        }
    }];

    return {
        filterType: filterType,
        usersFilterOptions: usersFilterOptions,
        profilesFilterOptions: profilesFilterOptions,
        mediaFilterOptions: mediaFilterOptions,
        surveyFilterOptions: surveyFilterOptions,
        certificatesFilterOptions: certificatesFilterOptions,
        checksFilterOptions: checksFilterOptions,
        jobsFilterOptions: jobsFilterOptions,
        jobRequestsFilterOptions: jobRequestsFilterOptions,
        affiliatesFilterOptions: affiliatesFilterOptions,
        vouchesFilterOptions: vouchesFilterOptions,
        botManagerFilterOptions: botManagerFilterOptions,
        botSessionsFilterOptions: botSessionsFilterOptions,
        businessesFilterOptions: businessesFilterOptions,
        globalUsersFilterOptions: globalUsersFilterOptions,
        globalProfilesFilterOptions: globalProfilesFilterOptions,
        globalJobsFilterOptions: globalJobsFilterOptions,
        globalAffiliatesFilterOptions: globalAffiliatesFilterOptions,
        globalVouchesFilterOptions: globalVouchesFilterOptions,
        globalCertificatesFilterOptions: globalCertificatesFilterOptions,
        globalChecksFilterOptions: globalChecksFilterOptions,
        globalBotManagerFilterOptions: globalBotManagerFilterOptions,
        globalBotSessionsFilterOptions: globalBotSessionsFilterOptions,
        globalBusinessesFilterOptions: globalBusinessesFilterOptions,
        globalJobRequestsFilterOptions: globalJobRequestsFilterOptions
    };
}();

exports.default = FilterHelper;


/** WEBPACK FOOTER **
 ** ./client/app/utils/filter-helper.js
 **/